import axios from 'axios'

const path = 'keystores'

export default {
  async createKeyStore(keyStoreCreationRequest) {
    await axios.post(`${path}`, keyStoreCreationRequest)
  },

  async deleteKeyStore(name) {
    await axios.delete(`${path}/${name}`)
  },

  async getKeyStoreNames(activatedOnly = true) {
    const resp = await axios.get(`${path}/names`, {
      params: {
        'activated-only': activatedOnly
      }
    })
    return resp.data
  },

  async listKeyStores(q, pageRequest) {
    const resp = await axios.get(`${path}`, {
      params: {
        q,
        ...pageRequest
      }
    })
    return resp.data
  },

  async getKeyStoreEntries(name) {
    const resp = await axios.get(`${path}/${name}/entries`)
    return resp.data
  },

  async activateKeyStore(name, keyStoreActivationRequest) {
    await axios.post(`${path}/${name}/activate`, keyStoreActivationRequest)
  },

  async deactivateKeyStore(name) {
    await axios.post(`${path}/${name}/deactivate`)
  },

  async isMpcmProviderConfigured() {
    const resp = await axios.get(`${path}/provider/mpcm`)
    return resp.data
  }
}
